"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/segmentedButtons/index.ts
var segmentedButtons_exports = {};
__export(segmentedButtons_exports, {
  default: () => SegmentedButtons_default
});
module.exports = __toCommonJS(segmentedButtons_exports);
var import_index = require("./index.css");

// src/segmentedButtons/SegmentedButtons.tsx
var import_classnames3 = __toESM(require("classnames"));

// src/segmentedButtons/_SegmentedButton.tsx
var import_classnames2 = __toESM(require("classnames"));
var import_react = require("react");

// src/fontAwesomeV6Icon/FontAwesomeV6Icon.tsx
var import_classnames = __toESM(require("classnames"));
var import_jsx_runtime = require("react/jsx-runtime");
var FontAwesomeV6Icon = ({
  iconStyle,
  iconFamily,
  iconName,
  className,
  title,
  animationType,
  ...HTMLAttributes
}) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
  "i",
  {
    "data-testid": "font-awesome-v6-icon",
    className: (0, import_classnames.default)(
      iconFamily && `fa-${iconFamily}`,
      iconStyle && `fa-${iconStyle}`,
      iconName && `fa-${iconName}`,
      // Default icon style is solid, but only when no iconFamily prop is provided
      !iconFamily && !iconStyle && "fa-solid",
      animationType && `fa-${animationType}`,
      className
    ),
    title,
    ...HTMLAttributes
  }
);
var FontAwesomeV6Icon_default = FontAwesomeV6Icon;

// src/segmentedButtons/segmentedButtons.module.scss
var segmentedButtons_module_default = {
  "heading-xxl": "segmentedButtons-module__heading-xxl___gt-9O",
  "wrapper": "segmentedButtons-module__wrapper___9nPTW",
  "heading-xl": "segmentedButtons-module__heading-xl___7tnOg",
  "heading-lg": "segmentedButtons-module__heading-lg___MpbvR",
  "heading-md": "segmentedButtons-module__heading-md___pWdJL",
  "heading-sm": "segmentedButtons-module__heading-sm___UeaOS",
  "heading-xs": "segmentedButtons-module__heading-xs___kTr02",
  "body-one": "segmentedButtons-module__body-one___aheqK",
  "body-two": "segmentedButtons-module__body-two___U-rKW",
  "body-three": "segmentedButtons-module__body-three___TwIU3",
  "body-four": "segmentedButtons-module__body-four___DTFqZ",
  "overline-one": "segmentedButtons-module__overline-one___tTBqf",
  "overline-two": "segmentedButtons-module__overline-two___vXHNL",
  "overline-three": "segmentedButtons-module__overline-three___0rsL3",
  "strong": "segmentedButtons-module__strong___vB8XQ",
  "em": "segmentedButtons-module__em___pgBqv",
  "figcaption": "segmentedButtons-module__figcaption___d1aOj",
  "no-margin": "segmentedButtons-module__no-margin___g7iJs",
  "segmentedButtons": "segmentedButtons-module__segmentedButtons___C1thL",
  "segmentedButton": "segmentedButtons-module__segmentedButton___0xaE7",
  "selectedSegmentedButton": "segmentedButtons-module__selectedSegmentedButton___mSaDx",
  "segmentedButtons-primary": "segmentedButtons-module__segmentedButtons-primary___SRy08",
  "segmentedButtons-strong": "segmentedButtons-module__segmentedButtons-strong___6uWl3",
  "segmentedButtons-l": "segmentedButtons-module__segmentedButtons-l___92Bfu",
  "segmentedButton-withLabel": "segmentedButtons-module__segmentedButton-withLabel___eqkX0",
  "segmentedButton-iconOnly": "segmentedButtons-module__segmentedButton-iconOnly___70jvB",
  "segmentedButton-number": "segmentedButtons-module__segmentedButton-number___KFvlS",
  "segmentedButtons-m": "segmentedButtons-module__segmentedButtons-m___ogl1A",
  "segmentedButtons-s": "segmentedButtons-module__segmentedButtons-s___bcFQC",
  "segmentedButtons-xs": "segmentedButtons-module__segmentedButtons-xs___TWfj2"
};

// src/segmentedButtons/_SegmentedButton.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var SegmentedButton = ({
  label,
  ariaLabel,
  disabled,
  selected,
  buttonType = "withLabel",
  iconLeft,
  iconRight,
  icon,
  value,
  onChange,
  id
}) => {
  const handleClick = (0, import_react.useCallback)(() => onChange(value), [onChange, value]);
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)(
    "button",
    {
      id,
      "aria-label": ariaLabel,
      type: "button",
      disabled,
      onClick: handleClick,
      className: (0, import_classnames2.default)(
        segmentedButtons_module_default.segmentedButton,
        segmentedButtons_module_default[`segmentedButton-${buttonType}`],
        selected && segmentedButtons_module_default.selectedSegmentedButton
      ),
      children: [
        buttonType === "iconOnly" && icon && /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
          FontAwesomeV6Icon_default,
          {
            iconName: icon.iconName,
            iconStyle: icon.iconStyle,
            title: icon.title
          }
        ),
        buttonType === "withLabel" && iconLeft && /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
          FontAwesomeV6Icon_default,
          {
            iconName: iconLeft.iconName,
            iconStyle: iconLeft.iconStyle,
            title: iconLeft.title
          }
        ),
        label && /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("span", { children: label }),
        buttonType === "withLabel" && iconRight && /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
          FontAwesomeV6Icon_default,
          {
            iconName: iconRight.iconName,
            iconStyle: iconRight.iconStyle,
            title: iconRight.title
          }
        )
      ]
    }
  );
};
var SegmentedButton_default = SegmentedButton;

// src/segmentedButtons/SegmentedButtons.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var SegmentedButtons = ({
  buttons,
  selectedButtonValue,
  onChange,
  className,
  color = "primary",
  size = "m",
  type = "withLabel"
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
    "div",
    {
      className: (0, import_classnames3.default)(
        segmentedButtons_module_default.segmentedButtons,
        segmentedButtons_module_default[`segmentedButtons-${color}`],
        segmentedButtons_module_default[`segmentedButtons-${size}`],
        className
      ),
      children: buttons.map(
        ({
          label,
          ariaLabel,
          disabled,
          iconLeft,
          iconRight,
          icon,
          value,
          id
        }) => /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
          SegmentedButton_default,
          {
            selected: selectedButtonValue === value,
            label,
            ariaLabel,
            onChange,
            disabled,
            iconLeft,
            iconRight,
            icon,
            buttonType: type,
            value,
            id
          },
          label
        )
      )
    }
  );
};
var SegmentedButtons_default = SegmentedButtons;
//# sourceMappingURL=index.js.map